// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentDIV {
    position: relative;
    overflow: auto;
    background: var(--workflow-background);
    font-family: var(--workflow-font-family);
}

.moduleItem {
    position: absolute;
}

    .moduleItem .debugIcon.actualDebug {
        color: var(--primary-color);
    }

    .moduleItem .debugIcon.selectedDebug, .moduleItem .debugIconAdditional.hasAdditional {
        background: var(--workflow-breakpoint-selected-background);
        color: var(--workflow-breakpoint-selected-color);
    }

    .moduleItem .debugIcon {
        position: absolute;
        height: 24px;
        width: 24px;
        z-index: 2;
        border-radius: 12px;
        font-size: 16px;
        cursor: pointer;
        background: var(--workflow-breakpoint-background);
        color: var(--workflow-breakpoint-color);
    }

    .moduleItem .debugIconStartDIV {
        top: -12px;
        left: -12px;
    }

    .moduleItem .debugIconEndDIV {
        bottom: -12px;
        right: -12px;
    }

    .moduleItem .debugIconAdditional {
        top: -12px;
        right: -12px;
    }

.additionalTemplate {
    background-color: white;
    z-index: 3;
}
`, "",{"version":3,"sources":["webpack://./src/app/debugconsole/workflow/debug.workflow.breakpoint.control.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;IAEI;QACI,2BAA2B;IAC/B;;IAEA;QACI,0DAA0D;QAC1D,gDAAgD;IACpD;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,UAAU;QACV,mBAAmB;QACnB,eAAe;QACf,eAAe;QACf,iDAAiD;QACjD,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;AAEJ;IACI,uBAAuB;IACvB,UAAU;AACd","sourcesContent":[".contentDIV {\n    position: relative;\n    overflow: auto;\n    background: var(--workflow-background);\n    font-family: var(--workflow-font-family);\n}\n\n.moduleItem {\n    position: absolute;\n}\n\n    .moduleItem .debugIcon.actualDebug {\n        color: var(--primary-color);\n    }\n\n    .moduleItem .debugIcon.selectedDebug, .moduleItem .debugIconAdditional.hasAdditional {\n        background: var(--workflow-breakpoint-selected-background);\n        color: var(--workflow-breakpoint-selected-color);\n    }\n\n    .moduleItem .debugIcon {\n        position: absolute;\n        height: 24px;\n        width: 24px;\n        z-index: 2;\n        border-radius: 12px;\n        font-size: 16px;\n        cursor: pointer;\n        background: var(--workflow-breakpoint-background);\n        color: var(--workflow-breakpoint-color);\n    }\n\n    .moduleItem .debugIconStartDIV {\n        top: -12px;\n        left: -12px;\n    }\n\n    .moduleItem .debugIconEndDIV {\n        bottom: -12px;\n        right: -12px;\n    }\n\n    .moduleItem .debugIconAdditional {\n        top: -12px;\n        right: -12px;\n    }\n\n.additionalTemplate {\n    background-color: white;\n    z-index: 3;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
